// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".search-found[data-v-15674900]{font-family:\"Roboto\";font-style:normal;font-weight:400;font-size:16px;line-height:20px;white-space:nowrap;color:#2d3748}.search-found[data-v-15674900]>:first-child{font-weight:700}.skeleton[data-v-15674900]{height:20px;border-radius:10px;background-image:linear-gradient(90deg,#ddd,#e8e8e8 40px,#ddd 80px)!important;background-size:600px;animation:shine-lines 1.2s linear infinite}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
